// extracted by mini-css-extract-plugin
module.exports = {"accountNavButton":"BM","menuBackground":"BN","navArrow":"BO","avatar":"BP","userName":"BQ","active":"BR","b":"BS","a":"BT"};